export const maxSeriesCount = 4

export const MODE_COMBINED = 'combined'
export const MODE_GRID = 'grid'
export const MODE_FACET = 'facet'
export const MODE_DEFAULT = 'default'

export const CHART_MODE_GRID = 'grid'
export const CHART_MODE_STACKED = 'stacked'
export const CHART_MODE_GROUPED = 'grouped'
export const CHART_MODE_DEFAULT = 'default'

// export const START_MARKER = '# fragmentStart'
// export const END_MARKER = '# fragmentEnd'

export const OPERATORS = ['eq', 'in', 'nin']
